import type { IAddress } from '@/types';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IPickUpInfoProps extends IAddress {
  ahName: string;
}

export const PickUpInfo: React.FC<IPickUpInfoProps> = ({
  ahName,
  city,
  countryCode,
  streetAddress,
  zipCode,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box>
      <Text textTransform="uppercase">{t('QUOTE_DETAILS.PICK_UP')}</Text>
      <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
        {ahName}
      </Text>
      <Text>
        {streetAddress}
        <br /> {zipCode} {city} {countryCode}
      </Text>
    </Box>
  );
};
